import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const HeartOutlinedIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke='currentColor'
    {...props}
  >
    <path
      d="M12.5967 6.03125C14.6831 3.89743 18.1167 3.89756 20.2031 6.03125C22.2243 8.09838 22.2243 11.4016 20.2031 13.4688L13.1035 20.7295C12.4979 21.3482 11.502 21.3483 10.8965 20.7295L3.79688 13.4688C1.77586 11.4017 1.77594 8.09835 3.79688 6.03125C5.8833 3.89748 9.31688 3.89751 11.4033 6.03125L12 6.64062L12.5967 6.03125ZM19.3447 6.87012C17.729 5.21813 15.0707 5.218 13.4551 6.87012L12.4287 7.91992C12.3159 8.035 12.1612 8.09961 12 8.09961C11.8388 8.09952 11.6841 8.03506 11.5713 7.91992L10.5449 6.87012C8.92925 5.21807 6.27094 5.21806 4.65527 6.87012C3.09032 8.47087 3.09025 11.0292 4.65527 12.6299L11.7539 19.8906C11.8887 20.0284 12.1112 20.0282 12.2461 19.8906L19.3447 12.6299C20.9099 11.0291 20.9099 8.47089 19.3447 6.87012Z"
      fill="currentColor"
    />
  </SvgIcon>
)
